import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  containerClassName?: string;
}
export function Section({
  children,
  className = '',
  id,
  containerClassName = ''
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 w-full ${className}`} data-id="element-199">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className={`px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto w-full ${containerClassName}`} data-id="element-200">
        {children}
      </motion.div>
    </section>;
}